import React from 'react';
import { Ruler, ShoppingBag, Truck, UserRound } from 'lucide-react';
import { imgSrc } from './tiendaAdminApi';

const MEDIDAS = { atelier: 'Medidas: coordinar en el atelier', videollamada: 'Medidas: coordinar por videollamada' };

const Seleccion = ({ s }) => (
  <li className="flex gap-3 py-2">
    <div className="h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-zinc-100 p-1">
      {s.tipo === 'texto'
        ? <span className="flex h-full items-center justify-center text-sm font-bold text-black">{s.texto}</span>
        : s.opciones[0]?.imagen_url && <img src={imgSrc(s.opciones[0].imagen_url)} alt="" className="h-full w-full object-contain" />}
    </div>
    <div className="min-w-0">
      <p className="text-xs uppercase tracking-wider text-zinc-500">{s.grupo_nombre}</p>
      <p className="text-sm font-medium text-white">{s.texto || s.opciones.map(o => o.titulo).join(', ')}</p>
      {s.ubicacion && <p className="text-xs text-amber-300" data-testid="venta-bordado-detalle">Bordado en {s.ubicacion.titulo} · hilo {s.color_hilo?.nombre}</p>}
      {s.opciones.map(o => o.especificaciones && <p key={o.id} className="whitespace-pre-line text-xs text-zinc-400">{o.especificaciones}</p>)}
    </div>
  </li>
);

const Comprador = ({ c }) => (
  <div className="mt-3 rounded-lg border border-zinc-700/60 bg-zinc-900/40 p-3 text-sm text-zinc-300" data-testid="venta-comprador-invitado">
    <p className="mb-1 flex items-center gap-2 text-xs uppercase tracking-wider text-zinc-500"><UserRound className="h-4 w-4" />Datos ingresados en la tienda (sin cuenta)</p>
    <p>{c.nombre} · {c.telefono} · {c.correo} · {c.tipo_documento} {c.numero_documento}</p>
    {c.cliente_existente && (
      <p className="mt-1 text-xs text-amber-300" data-testid="venta-cliente-existente">El teléfono ya estaba registrado: la venta se vinculó al cliente existente sin modificar sus datos.</p>
    )}
  </div>
);

const textoMedidas = (m) => (m?.registradas ? 'Tiene medidas registradas' : MEDIDAS[m?.coordinacion] || 'Sin medidas: contactar al cliente');

export default function CompraOnlineVenta({ orden }) {
  const c = orden.compra_online;
  if (!c) return null;
  return (
    <div className="rounded-xl border border-emerald-600/30 bg-emerald-900/10 p-5" data-testid="venta-compra-online">
      <h3 className="mb-3 flex items-center gap-2 font-semibold text-white">
        <ShoppingBag className="h-5 w-5 text-emerald-400" />{c.invitado ? 'Compra online sin cuenta' : 'Compra online Mi JPM'} · {c.producto_nombre}
      </h3>
      <ul className="divide-y divide-zinc-700/50">{c.selecciones.map((s, i) => <Seleccion key={i} s={s} />)}</ul>
      <div className="mt-3 grid gap-2 text-sm text-zinc-300 sm:grid-cols-2">
        <p className="flex gap-2"><Truck className="h-4 w-4 shrink-0 text-amber-400" />{c.envio?.titulo}{c.envio?.costo ? ` (${c.envio.costo})` : ''}{c.envio?.direccion ? ` · ${c.envio.direccion}` : ''}</p>
        <p className="flex gap-2" data-testid="venta-medidas"><Ruler className="h-4 w-4 shrink-0 text-amber-400" />{textoMedidas(c.medidas)}</p>
        {c.notas && <p className="sm:col-span-2">Notas del cliente: {c.notas}</p>}
      </div>
      {c.invitado && c.comprador && <Comprador c={c.comprador} />}
    </div>
  );
}
